<template>
  <modal name="show-category-info-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out" :width="800" :height="450">
    <h4 class="text-center panel-heading">Categorie informatie</h4>
    <form @submit.prevent="handleSubmit()" v-if="$can('btonly')">
      <div class="col-sm-12 mb-20">
        <label>Informatie</label>
        <textarea type="text" class="form-control" style="resize: none" rows="10" id="info" v-model="categoryInformation.info"
                  placeholder="..."></textarea>
      </div>
      <div class="col-sm-12 mb-20">
        <label>Afbeelding (150 x 150)</label>
        <input type="file"
               @change="upload($event.target.files)" accept="image/*">
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-4">
            <button type="submit" class="btn btn-danger">Opslaan</button>
          </div>
        </div>
      </div>
    </form>
    <div v-if="!$can('btonly')">
      <div class="row">
        <div class="col-sm-12 mb-20" style="padding: 20px">
          <p>{{categoryInformation.info}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 mb-20" v-if="categoryInformation.imageLocation">
          <lightbox class="col-sm-4 col-sm-offset-4"
            :images="[{src: BACKEND_BASE_URL + '/images/' + categoryInformation.imageLocation}]">
          </lightbox>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'ShowCategoryInfo',
    data () {
      return {
        BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
        categoryInformation: {
          categoryId: '',
          info: '',
          imageLocation: ''
        },
        file: null
      }
    },
    methods: {
      handleSubmit () {
        this.$store.commit(types.SET_CATEGORY_INFO_TO_CREATE, this.categoryInformation)
        this.$store.dispatch('saveCategoryInfo').then(() => {
          if (this.isCategoryInfoSaved) {
            this.categoryInformation.categoryId = ''
            this.categoryInformation.info = ''
            this.categoryInformation.imageLocation = null

            this.$modal.hide('show-category-info-modal')
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan deze informatie niet opslaan, probeer het later opnieuw!'})
          }
        })
      },
      beforeOpen (event) {
        if (event.params.category) {
          this.categoryInformation.categoryId = event.params.category
          this.categoryInformation.imageLocation = null

          this.$store.dispatch('getCategoryInfo', event.params.category).then(() => {
            if (this.categoryInfo) {
              this.categoryInformation.info = this.categoryInfo.info
              if (this.categoryInfo.imageLocation) {
                this.categoryInformation.imageLocation = this.categoryInfo.imageLocation
              }
            }
          })
        }
      },
      upload (image) {
        let data = new FormData()
        if (image !== '') {
          this.file = image.item(0)
          data.append('images', this.file, this.file.name)

          this.$store.dispatch('uploadImage', data).then(() => {
            if (this.imageLocation) {
              this.categoryInformation.imageLocation = this.imageLocation
            } else {
              this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan deze afbeelding niet uploaden!'})
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        imageLocation: 'imageLocation',
        isCategoryInfoSaved: 'isCategoryInfoSaved',
        categoryInfo: 'categoryInfo'
      })
    }
  }
</script>

<style scoped>
  .mb-20 {
    margin-bottom: 20px;
  }
</style>
